module.exports = __webpack_public_path__ + "static/media/promo-tag.9a190be0.svg";